import script from "./ModuleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleList.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleList.vue?vue&type=style&index=0&id=4a8aab2f&lang=scss"

const __exports__ = script;

export default __exports__